import { Box } from '@chakra-ui/react'
import { Select } from 'components/Select'
import moment from 'moment'

export const MonthYearSelect = ({
  fromYear = 1992,
  month,
  onMonthSelect,
  onYearSelect,
}: {
  fromYear?: number
  month: moment.Moment
  onMonthSelect: (currentMonth: moment.Moment, newMonthVal: string) => void
  onYearSelect: (currentMonth: moment.Moment, newMonthVal: string) => void
}) => {
  return (
    <Box
      px={4}
      style={{
        display: 'flex',
        justifyContent: 'center',
      }}
      gap={2}
      bg='white'
    >
      <Select
        menuHeight='200px'
        value={{
          label: month.format('MMMM'),
          value: month.month(),
        }}
        onChange={(e: any) => {
          onMonthSelect(month, e.value)
        }}
        options={moment.months().map((label, value) => {
          return {
            label,
            value,
          }
        })}
      />
      <Select
        menuHeight='200px'
        value={{
          label: month.format('YYYY'),
          value: month.year(),
        }}
        onChange={(e: any) => {
          onYearSelect(month, e.value)
        }}
        options={Array.from(
          { length: moment().year() - fromYear + 1 },
          (v, i) => fromYear + i
        )
          .sort((a, b) => b - a)
          .map((label, value) => {
            return {
              label,
              value: label,
            }
          })}
      />
    </Box>
  )
}
